/**
 * Shared color constants — mirrors key values from static/styles/variables/colors-variables.scss.
 * Use these in TSX/JS contexts where SCSS variables are not available.
 */

export const colors = {
  primary700: '#142B53',
  gray50: '#f9fafb',
  white: '#ffffff',
} as const;
